import { useMemo, useContext } from 'react';
import { intl, LanguageBaseContext } from 'dmsbasereact';

export const useTrainingAlerts = (accountStatus, needsTraining = false) => {
  const { language } = useContext(LanguageBaseContext);

  return useMemo(() => {
    const alerts = [];

    // PENDING_TRAINING (value 4) OR person-level training requirement
    // Show alert if: status is PENDING_TRAINING OR (ACTIVE but training not completed)
    if (accountStatus === 4 || needsTraining) {
      alerts.push({
        id: 'pending-training',
        severity: 'warning',
        title: intl.get('training_required').d('Treinamento Obrigatório'),
        message: intl.get('training_required_message').d(
          'Você precisa concluir o treinamento obrigatório para ter acesso completo ao sistema. Complete o treinamento \'Prescrição e Dispensação\' antes de dispensar medicamentos.'
        ),
        dismissible: false,
      });
    }

    // PENDING_RECYCLING_TRAINING (value 10)
    if (accountStatus === 10) {
      alerts.push({
        id: 'pending-recycling-training',
        severity: 'warning',
        title: intl.get('training_recycling_required').d('Treinamento de Reciclagem Obrigatório'),
        message: intl.get('training_recycling_required_message').d(
          'Necessário fazer o treinamento de reciclagem, devido ao excesso de dispensacões onde a data da dispensacão é diferente da data do registro no sistema. Complete o treinamento de reciclagem \'Treinamento Lenalidomida\' para restaurar o acesso à dispensação.'
        ),
        dismissible: false,
      });
    }

    return alerts;
  }, [accountStatus, needsTraining, language]); // eslint-disable-line react-hooks/exhaustive-deps -- language is required for i18n updates
};
